<div class="mat-typography">
    <div class="mat-typography">
        <p class="content-p">Missed Abutting PRs: <span [ngClass]="{'red-text': isRed('missedAbuttingPRsCount')}">{{
                zcMetaData ?
                formatNumber(zcMetaData.missedAbuttingPRsCount, 'en-US') : 'No data' }}</span></p>
        <p class="content-p">Missed Abutting Streets: <span
                [ngClass]="{'red-text': isRed('missedAbuttingStreetsCount')}">{{ zcMetaData ?
                formatNumber(zcMetaData.missedAbuttingStreetsCount, 'en-US') : 'No data'
                }}</span>
        </p>
        <p class="content-p">Missed PRs Tags: <span [ngClass]="{'red-text': isRed('missedPRTagsCount')}">{{
                zcMetaData ? formatNumber(zcMetaData.missedPRTagsCount, 'en-US') : 'No data' }}</span></p>
    </div>
</div>